import { useState, useCallback, useEffect, createRef, useRef } from 'react'

//* HOCs
import { withUIContext, withUserContext } from 'context'

//* Components
import { Text, Logo, ButtonSimple, Container, CustomLink, Input, Icon, Image, Notifications, Avatar } from 'components/common'
import { Input as AntInput } from 'antd'

import { useRouter } from 'next/router'

//* Style
import HeaderStyle from './style'
import AnimateHeight from 'react-animate-height'

const AppHeader = ({ disableDomScroll, isLoggedIn, user, winWidth, ...props }) => {
    const inputRef = createRef()
    const searchRef = useRef()
    const router = useRouter()

    const [notificationsBlock, setNotificationsBlock] = useState(false)
    const [logOutBlock, setLogOutBlock] = useState(false)
    const [toggleHgt, setToggleHgt] = useState(0)
    const [isNotify, setIsNotify] = useState(false)

    useEffect(() => {
        if (notificationsBlock || logOutBlock) {
            document.addEventListener('click', clickHandler)
        }

        return () => {
            document.removeEventListener('click', clickHandler)
        }
    }, [notificationsBlock, logOutBlock])

    useEffect(() => {
        setNotificationsBlock(false)
        setLogOutBlock(false)
        setToggleHgt(0)

    }, [router])

    useEffect(() => {
        if (router.pathname != '/search') {
            inputRef.current.state.value = ''
        }
    }, [router.asPath])

    const clickHandler = useCallback((e) => {
        if (!(!!e.path.find((el) => el.classList?.contains('icon-pop')))) {
            let isExist = e?.path.find((el) => el.classList?.contains('notifications')) || e?.path.find((el) => el.classList?.contains('settings-popup'))

            if (!isExist) {
                setNotificationsBlock(false)
                setLogOutBlock(false)
            }
        }
    }, [])

    const onSearch = () => {
        if (inputRef.current.input.value.length > 2) {
            router.push(`/search?s=${inputRef.current.input.value}`)
        }
    }

    const toggleNotification = () => {
        setNotificationsBlock(!notificationsBlock);
        setLogOutBlock(false)
        setIsNotify(false)
        props.readNotify()

    }

    useEffect(() => {
        setIsNotify(user?.notify)
    }, [user])


    return (
        <HeaderStyle className='flexBox'>
            <Container className='flexBox spaceBetween alignMiddle'>
                <Logo />
                {winWidth > 601 ? (
                    <div className={`search ${isLoggedIn ? 'loggedIn' : ''}`}>
                        <div className={'ant-form-item'}>
                            <AntInput
                                ref={inputRef}
                                onPressEnter={onSearch}
                                className='input-text'
                                placeholder={'Search for Debate Topics, Keywords or Users'}
                            />
                        </div>
                        <Icon onClick={onSearch} className={'op-search grey'} />
                    </div>
                ) : <Icon onClick={() => setToggleHgt(toggleHgt === 0 ? 'auto' : 0)} className={'op-search mobile grey'} />}
                <div className='buttons-cont flexBox alignMiddle'>
                    {(isLoggedIn && user) ? (
                        <>
                            <CustomLink className='craete-debate' url={'/profile/debate/create'}>
                                {winWidth > 601 ?
                                    <ButtonSimple text='Create debate' />
                                    :
                                    <Icon className='op-plus' />
                                }
                            </CustomLink>
                            <CustomLink url={`/${user.username}`} className='avatar'>
                                <Avatar src={user.avatar} />
                            </CustomLink>
                            <Icon
                                onClick={toggleNotification}
                                className={`cursorPointer op-ring icon-pop ${isNotify ? 'active' : ''}`}
                            />
                            <Icon onClick={() => { setLogOutBlock(!logOutBlock); setNotificationsBlock(false) }}
                                className='cursorPointer icon-pop op-settings' />
                            <div className={`settings-popup ${logOutBlock ? 'active' : ''}`}>
                                <CustomLink url='/profile/edit'>
                                    <Text tag='h5' className='PopReg h5' text='Edit Profile' />
                                </CustomLink>
                                <CustomLink url='#' onClick={props.logout}>
                                    <Text tag='h5' className='PopReg h5' text='Log Out' />
                                </CustomLink>
                            </div>
                            <Notifications isOpen={notificationsBlock} />
                        </>
                    ) : (
                        <>
                            <CustomLink url={'/?c=login'}>
                                <ButtonSimple text='Login' />
                            </CustomLink>
                            <CustomLink url={'/?c=sign-up'}>
                                <ButtonSimple className='white purple' text='Sign Up' />
                            </CustomLink>
                        </>
                    )}
                </div>
                {winWidth < 601 && <AnimateHeight ref={searchRef} duration={500} height={toggleHgt} className={`search mobile ${isLoggedIn ? 'loggedIn' : ''}`}>
                    <div className={'ant-form-item'}>
                        <AntInput
                            ref={inputRef}
                            onPressEnter={onSearch}
                            className='input-text'
                            placeholder={'Search for Debate Topics, Keywords or Users'}
                        />
                        <Icon onClick={() => setToggleHgt(0)} className={'op-close grey'} />
                        <Icon onClick={onSearch} className={'op-search grey'} />
                    </div>
                </AnimateHeight>}
            </Container>
        </HeaderStyle>
    )
}

export default withUIContext(withUserContext(AppHeader,
    ['isLoggedIn', 'user', 'logout', 'readNotify']),
    ['disableDomScroll', 'winWidth'])
